import React, { Component } from 'react'
import '../styles/ThemeCalendar.css'
import moment from 'moment-timezone'
import utils from '../utils.json'

const weekLimit = utils.weekLimit

const stripHours = (time) => {
  return time.split(':').shift()
}

const stripMinutes = (time) => {
  return parseInt(time.split(':')[1]) > -1 ? time.split(':')[1] : '';
}

const themeCodeBuilder = (code) => {
  switch (code) {
    case '27':
      return 'la'
    case '28':
      return 'vbn'
    case '29':
      return 'abattoir'
    case '31':
      return 'yakuza'
    case '32':
      return 'tombeau'
    default:
      break
  }
}

const isOverMonthLimit = slotDate => slotDate < moment().add(weekLimit, 'w').subtract(1, 'd')

class ThemeCalendar extends Component {

  handleClick = (data) => {
    if (!data.target.className.includes("selected")) {
      this.props.handleClick(data.target.id)
    }
  }

  buildSlotCode = (booking) => {
    return `${themeCodeBuilder(booking.room_id)}|${booking.reservation_date}|${stripHours(booking.time_begin)}||${stripMinutes(booking.time_begin)}`
  }

  formatDate = (date) => {
    const formattedDate = date.format('l').split("/")
    let y, M, d

    y = formattedDate[2]
    M = formattedDate[1].length < 2 ? `0${formattedDate[1]}` : formattedDate[1]
    d = formattedDate[0].length < 2 ? `0${formattedDate[0]}` : formattedDate[0]

    if (this.props.lang === "fr") {
      return `${y}-${M}-${d}`
    } else {
      return `${y}-${d}-${M}`
    }
  }

  updateCells = () => {

    document.querySelectorAll("td").forEach(td => {
      td.classList.remove("theme-calendar--selected")
    })

    if (this.props.selectedSlots.length > 0) {
      this.props.selectedSlots.forEach(booking => {
        const formattedSlot = this.buildSlotCode(booking)
        const selectedCell = document.querySelectorAll(`[id^='${formattedSlot}']`)
        if (selectedCell.length > 0) {
          selectedCell[0].classList.add("theme-calendar-cell-all", "theme-calendar--selected")
          selectedCell[0].classList.remove("theme-calendar-unavailable")
          selectedCell[0].innerHTML = ""
          selectedCell[0].insertAdjacentHTML("afterBegin", `${formattedSlot.split("|")[2]}h`)
        }
      })
    }
  }

  checkAvailability = (slot, date) => {
    const minutesBefore = Number.isFinite(Number(slot.minutes_before_reservation)) ? Number(slot.minutes_before_reservation) : 60
    const inOneHour = moment().add(minutesBefore, 'minute')
    const hour = slot.time_begin
    const slotDate = moment(date + ' ' + hour, 'YYYY/MM/DD HH:mm:ss')
    return inOneHour < slotDate && isOverMonthLimit(slotDate)
  }

  checkIfRoomActive = (slots) => {
    if (slots[0].calendar.length === 0) {
      return emptyCalendar
    } else {
      return slots
    }
  }

  cancelCell = () => {
    Array.prototype.forEach.call(document.getElementsByClassName("theme-calendar-cell-all"), (el) => {
      if (!el.classList.contains(`theme-calendar-cell-all--${el.id.split("|")[0]}`) && !el.classList.contains("theme-calendar--selected")) {
        el.classList.remove("theme-calendar-cell-all")
        el.innerHTML = ""
        el.classList.add("theme-calendar-unavailable")
      }
    })
  }

  componentDidUpdate() {
    this.updateCells()
    this.cancelCell()
  }

  componentDidMount() {
    this.updateCells()
  }

  render() {
    const slots = this.checkIfRoomActive(this.props.slots)
    let maxSlots = 0;
    slots.forEach((slot) => {
      if (slot.calendar)
        slot.calendar.length > maxSlots ? maxSlots = slot.calendar.length : null;
    });


    return (
      <table className="theme-calendar theme-calendar--single-theme">
        <thead className="theme-calendar-header">
          <tr className="theme-calendar-header-row">
            {
             this.props.weekDays.map( (x, i) =>
                <th key={i}>{x}</th>
             )
            }
          </tr>
        </thead>
        <tbody className={`theme-calendar-body theme-calendar-body--${this.props.theme}`}>
          {
            Array.from({ length: maxSlots }).map((_, i) => (
              <tr key={i}>
                {
                  slots.map((slot, j) => (
                    slot.calendar[i].bookable && this.checkAvailability(slot.calendar[i], slot.day)
                      ? <td
                          key={`${i}-${j}`}
                          className={`theme-calendar-cell-all theme-calendar-cell-all--${this.props.theme} theme-calendar-cell-hour`}
                          id={`${this.props.theme}|${slot.day}|${stripHours(slot.calendar[i].time_begin)}|${stripHours(slot.calendar[i].id_room_calendar)}|${stripMinutes(slot.calendar[i].time_begin)}`}
                          onClick={data => this.handleClick(data)}
                        >
                          {`${stripHours(slot.calendar[i].time_begin)}:${stripMinutes(slot.calendar[i].time_begin)}`}
                        </td>
                      : <td
                          key={`${i}-${j}`}
                          id={`${this.props.theme}|${slot.day}|${stripHours(slot.calendar[i].time_begin)}|${stripHours(slot.calendar[i].id_room_calendar)}|${stripMinutes(slot.calendar[i].time_begin)}`}
                          className="theme-calendar-unavailable"
                        ></td>
                  ))
                }
              </tr>
            ))
          }
        </tbody>

      </table>
    );
  }
}

const emptyCalendar =
[
{
day: "2018-04-02",
calendar: [
{
already_booked_for: "0",
time_begin: "10:00:00",
time_end: "12:00:00",
id_room_calendar: "95",
normal_price_type: "c",
other_price_type: null,
necessary_resource_quantity: "1",
company_id: "30",
global_price: "c",
min_nb_resource_available: "-1",
bookable: true,
quantity_resource_booked: "0"
},
{
already_booked_for: "0",
time_begin: "12:00:00",
time_end: "14:00:00",
id_room_calendar: "96",
normal_price_type: "c",
other_price_type: null,
necessary_resource_quantity: "1",
company_id: "30",
global_price: "c",
min_nb_resource_available: "-1",
bookable: true,
quantity_resource_booked: "0"
},
{
already_booked_for: "0",
time_begin: "14:00:00",
time_end: "16:00:00",
id_room_calendar: "97",
normal_price_type: "c",
other_price_type: null,
necessary_resource_quantity: "1",
company_id: "30",
global_price: "c",
min_nb_resource_available: "-1",
bookable: true,
quantity_resource_booked: "0"
},
{
already_booked_for: "0",
time_begin: "16:00:00",
time_end: "18:00:00",
id_room_calendar: "98",
normal_price_type: "c",
other_price_type: null,
necessary_resource_quantity: "1",
company_id: "30",
global_price: "c",
min_nb_resource_available: "-1",
bookable: true,
quantity_resource_booked: "0"
},
{
already_booked_for: "0",
time_begin: "18:00:00",
time_end: "20:00:00",
id_room_calendar: "99",
normal_price_type: "p",
other_price_type: null,
necessary_resource_quantity: "1",
company_id: "30",
global_price: "p",
min_nb_resource_available: "-1",
bookable: true,
quantity_resource_booked: "0"
},
{
already_booked_for: "0",
time_begin: "20:00:00",
time_end: "22:00:00",
id_room_calendar: "100",
normal_price_type: "p",
other_price_type: null,
necessary_resource_quantity: "1",
company_id: "30",
global_price: "p",
min_nb_resource_available: "-1",
bookable: true,
quantity_resource_booked: "0"
},
{
already_booked_for: "0",
time_begin: "22:00:00",
time_end: "23:59:00",
id_room_calendar: "101",
normal_price_type: "p",
other_price_type: null,
necessary_resource_quantity: "1",
company_id: "30",
global_price: "p",
min_nb_resource_available: "-1",
bookable: true,
quantity_resource_booked: "0"
}
]
},
{
day: "2018-04-03",
calendar: [
{
already_booked_for: "0",
time_begin: "10:00:00",
time_end: "12:00:00",
id_room_calendar: "102",
normal_price_type: "c",
other_price_type: null,
necessary_resource_quantity: "1",
company_id: "30",
global_price: "c",
min_nb_resource_available: "-1",
bookable: true,
quantity_resource_booked: "0"
},
{
already_booked_for: "0",
time_begin: "12:00:00",
time_end: "14:00:00",
id_room_calendar: "103",
normal_price_type: "c",
other_price_type: null,
necessary_resource_quantity: "1",
company_id: "30",
global_price: "c",
min_nb_resource_available: "-1",
bookable: true,
quantity_resource_booked: "0"
},
{
already_booked_for: "0",
time_begin: "14:00:00",
time_end: "16:00:00",
id_room_calendar: "104",
normal_price_type: "c",
other_price_type: null,
necessary_resource_quantity: "1",
company_id: "30",
global_price: "c",
min_nb_resource_available: "-1",
bookable: true,
quantity_resource_booked: "0"
},
{
already_booked_for: "0",
time_begin: "16:00:00",
time_end: "18:00:00",
id_room_calendar: "105",
normal_price_type: "c",
other_price_type: null,
necessary_resource_quantity: "1",
company_id: "30",
global_price: "c",
min_nb_resource_available: "-1",
bookable: true,
quantity_resource_booked: "0"
},
{
already_booked_for: "0",
time_begin: "18:00:00",
time_end: "20:00:00",
id_room_calendar: "106",
normal_price_type: "p",
other_price_type: null,
necessary_resource_quantity: "1",
company_id: "30",
global_price: "p",
min_nb_resource_available: "-1",
bookable: true,
quantity_resource_booked: "0"
},
{
already_booked_for: "0",
time_begin: "20:00:00",
time_end: "22:00:00",
id_room_calendar: "107",
normal_price_type: "p",
other_price_type: null,
necessary_resource_quantity: "1",
company_id: "30",
global_price: "p",
min_nb_resource_available: "-1",
bookable: true,
quantity_resource_booked: "0"
},
{
already_booked_for: "0",
time_begin: "22:00:00",
time_end: "23:59:00",
id_room_calendar: "108",
normal_price_type: "p",
other_price_type: null,
necessary_resource_quantity: "1",
company_id: "30",
global_price: "p",
min_nb_resource_available: "-1",
bookable: true,
quantity_resource_booked: "0"
}
]
},
{
day: "2018-04-04",
calendar: [
{
already_booked_for: "0",
time_begin: "10:00:00",
time_end: "12:00:00",
id_room_calendar: "109",
normal_price_type: "c",
other_price_type: null,
necessary_resource_quantity: "1",
company_id: "30",
global_price: "c",
min_nb_resource_available: "-1",
bookable: true,
quantity_resource_booked: "1"
},
{
already_booked_for: "0",
time_begin: "12:00:00",
time_end: "14:00:00",
id_room_calendar: "110",
normal_price_type: "c",
other_price_type: null,
necessary_resource_quantity: "1",
company_id: "30",
global_price: "c",
min_nb_resource_available: "-1",
bookable: true,
quantity_resource_booked: "0"
},
{
already_booked_for: "0",
time_begin: "14:00:00",
time_end: "16:00:00",
id_room_calendar: "111",
normal_price_type: "c",
other_price_type: null,
necessary_resource_quantity: "1",
company_id: "30",
global_price: "c",
min_nb_resource_available: "-1",
bookable: true,
quantity_resource_booked: "0"
},
{
already_booked_for: "0",
time_begin: "16:00:00",
time_end: "18:00:00",
id_room_calendar: "112",
normal_price_type: "c",
other_price_type: null,
necessary_resource_quantity: "1",
company_id: "30",
global_price: "c",
min_nb_resource_available: "-1",
bookable: true,
quantity_resource_booked: "0"
},
{
already_booked_for: "0",
time_begin: "18:00:00",
time_end: "20:00:00",
id_room_calendar: "113",
normal_price_type: "p",
other_price_type: null,
necessary_resource_quantity: "1",
company_id: "30",
global_price: "p",
min_nb_resource_available: "-1",
bookable: true,
quantity_resource_booked: "0"
},
{
already_booked_for: "0",
time_begin: "20:00:00",
time_end: "22:00:00",
id_room_calendar: "114",
normal_price_type: "p",
other_price_type: null,
necessary_resource_quantity: "1",
company_id: "30",
global_price: "p",
min_nb_resource_available: "-1",
bookable: true,
quantity_resource_booked: "0"
},
{
already_booked_for: "0",
time_begin: "22:00:00",
time_end: "23:59:00",
id_room_calendar: "115",
normal_price_type: "p",
other_price_type: null,
necessary_resource_quantity: "1",
company_id: "30",
global_price: "p",
min_nb_resource_available: "-1",
bookable: true,
quantity_resource_booked: "0"
}
]
},
{
day: "2018-04-05",
calendar: [
{
already_booked_for: "0",
time_begin: "10:00:00",
time_end: "12:00:00",
id_room_calendar: "116",
normal_price_type: "c",
other_price_type: null,
necessary_resource_quantity: "1",
company_id: "30",
global_price: "c",
min_nb_resource_available: "-1",
bookable: true,
quantity_resource_booked: "0"
},
{
already_booked_for: "0",
time_begin: "12:00:00",
time_end: "14:00:00",
id_room_calendar: "117",
normal_price_type: "c",
other_price_type: null,
necessary_resource_quantity: "1",
company_id: "30",
global_price: "c",
min_nb_resource_available: "-1",
bookable: true,
quantity_resource_booked: "0"
},
{
already_booked_for: "0",
time_begin: "14:00:00",
time_end: "16:00:00",
id_room_calendar: "143",
normal_price_type: "c",
other_price_type: null,
necessary_resource_quantity: "1",
company_id: "30",
global_price: "c",
min_nb_resource_available: "-1",
bookable: true,
quantity_resource_booked: "0"
},
{
already_booked_for: "0",
time_begin: "16:00:00",
time_end: "18:00:00",
id_room_calendar: "118",
normal_price_type: "c",
other_price_type: null,
necessary_resource_quantity: "1",
company_id: "30",
global_price: "c",
min_nb_resource_available: "-1",
bookable: true,
quantity_resource_booked: "0"
},
{
already_booked_for: "0",
time_begin: "18:00:00",
time_end: "20:00:00",
id_room_calendar: "119",
normal_price_type: "p",
other_price_type: null,
necessary_resource_quantity: "1",
company_id: "30",
global_price: "p",
min_nb_resource_available: "-1",
bookable: true,
quantity_resource_booked: "0"
},
{
already_booked_for: "0",
time_begin: "20:00:00",
time_end: "22:00:00",
id_room_calendar: "120",
normal_price_type: "p",
other_price_type: null,
necessary_resource_quantity: "1",
company_id: "30",
global_price: "p",
min_nb_resource_available: "-1",
bookable: true,
quantity_resource_booked: "0"
},
{
already_booked_for: "0",
time_begin: "22:00:00",
time_end: "23:59:00",
id_room_calendar: "121",
normal_price_type: "p",
other_price_type: null,
necessary_resource_quantity: "1",
company_id: "30",
global_price: "p",
min_nb_resource_available: "-1",
bookable: true,
quantity_resource_booked: "0"
}
]
},
{
day: "2018-04-06",
calendar: [
{
already_booked_for: "0",
time_begin: "10:00:00",
time_end: "12:00:00",
id_room_calendar: "122",
normal_price_type: "c",
other_price_type: null,
necessary_resource_quantity: "1",
company_id: "30",
global_price: "c",
min_nb_resource_available: "-1",
bookable: true,
quantity_resource_booked: "0"
},
{
already_booked_for: "0",
time_begin: "12:00:00",
time_end: "14:00:00",
id_room_calendar: "123",
normal_price_type: "c",
other_price_type: null,
necessary_resource_quantity: "1",
company_id: "30",
global_price: "c",
min_nb_resource_available: "-1",
bookable: true,
quantity_resource_booked: "0"
},
{
already_booked_for: "0",
time_begin: "14:00:00",
time_end: "16:00:00",
id_room_calendar: "124",
normal_price_type: "c",
other_price_type: null,
necessary_resource_quantity: "1",
company_id: "30",
global_price: "c",
min_nb_resource_available: "-1",
bookable: true,
quantity_resource_booked: "0"
},
{
already_booked_for: "0",
time_begin: "16:00:00",
time_end: "18:00:00",
id_room_calendar: "125",
normal_price_type: "c",
other_price_type: null,
necessary_resource_quantity: "1",
company_id: "30",
global_price: "c",
min_nb_resource_available: "-1",
bookable: true,
quantity_resource_booked: "0"
},
{
already_booked_for: "0",
time_begin: "18:00:00",
time_end: "20:00:00",
id_room_calendar: "126",
normal_price_type: "p",
other_price_type: null,
necessary_resource_quantity: "1",
company_id: "30",
global_price: "p",
min_nb_resource_available: "-1",
bookable: true,
quantity_resource_booked: "0"
},
{
already_booked_for: "1",
time_begin: "20:00:00",
time_end: "22:00:00",
id_room_calendar: "127",
normal_price_type: "p",
other_price_type: null,
necessary_resource_quantity: "1",
company_id: "30",
global_price: "p",
bookable: false,
min_nb_resource_available: "-1",
quantity_resource_booked: "1"
},
{
already_booked_for: "0",
time_begin: "22:00:00",
time_end: "23:59:00",
id_room_calendar: "128",
normal_price_type: "p",
other_price_type: null,
necessary_resource_quantity: "1",
company_id: "30",
global_price: "p",
min_nb_resource_available: "-1",
bookable: true,
quantity_resource_booked: "0"
}
]
},
{
day: "2018-04-07",
calendar: [
{
already_booked_for: "0",
time_begin: "10:00:00",
time_end: "12:00:00",
id_room_calendar: "129",
normal_price_type: "p2",
other_price_type: null,
necessary_resource_quantity: "1",
company_id: "30",
global_price: "p2",
min_nb_resource_available: "-1",
bookable: true,
quantity_resource_booked: "0"
},
{
already_booked_for: "0",
time_begin: "12:00:00",
time_end: "14:00:00",
id_room_calendar: "130",
normal_price_type: "p2",
other_price_type: null,
necessary_resource_quantity: "1",
company_id: "30",
global_price: "p2",
min_nb_resource_available: "-1",
bookable: true,
quantity_resource_booked: "0"
},
{
already_booked_for: "0",
time_begin: "14:00:00",
time_end: "16:00:00",
id_room_calendar: "131",
normal_price_type: "p2",
other_price_type: null,
necessary_resource_quantity: "1",
company_id: "30",
global_price: "p2",
min_nb_resource_available: "-1",
bookable: true,
quantity_resource_booked: "0"
},
{
already_booked_for: "0",
time_begin: "16:00:00",
time_end: "18:00:00",
id_room_calendar: "132",
normal_price_type: "p2",
other_price_type: null,
necessary_resource_quantity: "1",
company_id: "30",
global_price: "p2",
min_nb_resource_available: "-1",
bookable: true,
quantity_resource_booked: "1"
},
{
already_booked_for: "0",
time_begin: "18:00:00",
time_end: "20:00:00",
id_room_calendar: "133",
normal_price_type: "p2",
other_price_type: null,
necessary_resource_quantity: "1",
company_id: "30",
global_price: "p2",
min_nb_resource_available: "-1",
bookable: true,
quantity_resource_booked: "1"
},
{
already_booked_for: "0",
time_begin: "20:00:00",
time_end: "22:00:00",
id_room_calendar: "134",
normal_price_type: "p2",
other_price_type: null,
necessary_resource_quantity: "1",
company_id: "30",
global_price: "p2",
min_nb_resource_available: "-1",
bookable: true,
quantity_resource_booked: "1"
},
{
already_booked_for: "0",
time_begin: "22:00:00",
time_end: "23:59:00",
id_room_calendar: "135",
normal_price_type: "p2",
other_price_type: null,
necessary_resource_quantity: "1",
company_id: "30",
global_price: "p2",
min_nb_resource_available: "-1",
bookable: true,
quantity_resource_booked: "0"
}
]
},
{
day: "2018-04-08",
calendar: [
{
already_booked_for: "0",
time_begin: "10:00:00",
time_end: "12:00:00",
id_room_calendar: "136",
normal_price_type: "p2",
other_price_type: null,
necessary_resource_quantity: "1",
company_id: "30",
global_price: "p2",
min_nb_resource_available: "-1",
bookable: true,
quantity_resource_booked: "0"
},
{
already_booked_for: "0",
time_begin: "12:00:00",
time_end: "14:00:00",
id_room_calendar: "137",
normal_price_type: "p2",
other_price_type: null,
necessary_resource_quantity: "1",
company_id: "30",
global_price: "p2",
min_nb_resource_available: "-1",
bookable: true,
quantity_resource_booked: "0"
},
{
already_booked_for: "0",
time_begin: "14:00:00",
time_end: "16:00:00",
id_room_calendar: "138",
normal_price_type: "p2",
other_price_type: null,
necessary_resource_quantity: "1",
company_id: "30",
global_price: "p2",
min_nb_resource_available: "-1",
bookable: true,
quantity_resource_booked: "0"
},
{
already_booked_for: "0",
time_begin: "16:00:00",
time_end: "18:00:00",
id_room_calendar: "139",
normal_price_type: "p2",
other_price_type: null,
necessary_resource_quantity: "1",
company_id: "30",
global_price: "p2",
min_nb_resource_available: "-1",
bookable: true,
quantity_resource_booked: "0"
},
{
already_booked_for: "0",
time_begin: "18:00:00",
time_end: "20:00:00",
id_room_calendar: "140",
normal_price_type: "p2",
other_price_type: null,
necessary_resource_quantity: "1",
company_id: "30",
global_price: "p2",
min_nb_resource_available: "-1",
bookable: true,
quantity_resource_booked: "0"
},
{
already_booked_for: "0",
time_begin: "20:00:00",
time_end: "22:00:00",
id_room_calendar: "141",
normal_price_type: "p2",
other_price_type: null,
necessary_resource_quantity: "1",
company_id: "30",
global_price: "p2",
min_nb_resource_available: "-1",
bookable: true,
quantity_resource_booked: "0"
},
{
already_booked_for: "0",
time_begin: "22:00:00",
time_end: "23:59:00",
id_room_calendar: "142",
normal_price_type: "p2",
other_price_type: null,
necessary_resource_quantity: "1",
company_id: "30",
global_price: "p2",
min_nb_resource_available: "-1",
bookable: true,
quantity_resource_booked: "0"
}
]
}
]

export default ThemeCalendar



// WEBPACK FOOTER //
// ./src/components/ThemeCalendar.js